<template>
  <div class="vitamines-mineraux-page">
    <!-- Section d'en-tête avec titre, breadcrumb et bouton "Acheter en ligne" -->
    <section class="header-section">
      <h1 class="page-title">Vitamines & Minéraux</h1>
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/produits">Produits</a> > <a href="/reactifs">Vitamines & Minéraux</a>
      </div>
      <!-- Bouton "Acheter en ligne" -->
      <button class="buy-online-btn" @click="goToCart">Acheter en ligne</button>
    </section>

    <!-- Section de produits -->
    <section class="products-section">
      <p class="page-description">
        Découvrez notre large gamme de vitamines et de minéraux, essentiels pour le bien-être et la santé. 
        Nous proposons des produits de qualité pour répondre à tous vos besoins nutritionnels.
      </p>

      <h2>Nos Produits</h2>
      <div class="product-grid">
        <div class="product-item" v-for="(product, index) in products" :key="index">
          <img :src="product.image" :alt="product.name" class="product-image"/>
          <h3 class="product-name">{{ product.name }}</h3>
          <p class="product-description">{{ product.description }}</p>
          <button class="learn-more-btn">En savoir plus</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'VitaminesMineraux',
  data() {
    return {
      products: [
        {
          name: 'Vitamine C',
          description: 'Un puissant antioxydant qui aide à renforcer le système immunitaire.',
          //image: require('@/assets/vita.png')
        },
        {
          name: 'Vitamine D',
          description: 'Essentielle pour des os solides et un bon fonctionnement musculaire.',
          //image: require('@/assets/img1.jpg')
        },
        {
          name: 'Magnésium',
          description: 'Aide à maintenir un métabolisme énergétique normal et à réduire la fatigue.',
          //image: require('@/assets/img2.jpg')
        },
        // Ajoutez plus de produits ici
      ]
    };
  },
  methods: {
    goToCart() {
      this.$router.push('/panier');
    }
  }
};
</script>

<style scoped>
.vitamines-mineraux-page {
  padding: 0px;
  font-family: 'Poppins', sans-serif;
}

.header-section {
  position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/vitaa.jpeg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77);
  padding: 100px 0;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 36px;
  color: #e3e8ec;
  margin-bottom: 15px;
}

.breadcrumb {
  font-size: 12px;
  color: #e3dcdc;
  margin-top: 10px;
}

.breadcrumb a {
  color: #dfdfe8;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3;
}

/* Style du bouton "Acheter en ligne" */
.buy-online-btn {
  margin-top: 20px;
  background-color: #27ae60;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.buy-online-btn:hover {
  background-color: #2ecc71;
}

.page-description {
  font-size: 18px;
  color: #34495e;
}

.products-section {
  text-align: center;
  margin-top: 40px;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.product-item {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
}

.product-item:hover {
  transform: translateY(-5px);
}

.product-image {
  max-width: 100%;
  border-radius: 10px;
  margin-bottom: 15px;
}

.product-name {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
}

.product-description {
  font-size: 16px;
  color: #7f8c8d;
  margin-bottom: 15px;
}

.learn-more-btn {
  background-color: #27ae60;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.learn-more-btn:hover {
  background-color: #2ecc71;
}
</style>
